/* eslint-disable */
/* 账单只读详情*/
import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Input,
  ConfigProvider,
  Button,
  Space,
} from "antd";
import { CreditCardOutlined, FileImageOutlined} from "@ant-design/icons";
import { CustomUpload } from "@/hocComponents";
import moment from "moment";
import commonFn from "@/utils/commonFn";

const UtilityPaymentModal = ({
  open,
  handleCancel,
  form,
  record,
}) => {
  const [filePaths, setFilePaths] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);
  
  useEffect(() => {
    if (open) {
      const formattedRecord = {
        ...record,
        amount: record?.amount && commonFn.amountToDollarFn(record.amount) || '',
        invoiceDate: record?.invoiceDate && moment(record.invoiceDate).format("MM/DD/YYYY") || '',
        postedDate: record?.postedDate && moment(record.postedDate).format("MM/DD/YYYY") || '',
        clearedDate: record?.clearedDate && moment(record.clearedDate).format("MM/DD/YYYY") || '',
      };
      form.setFieldsValue(formattedRecord);
    }
  }, [open]);


  const formItemDocFn = () => {
    const formItemList = [
      {value: 'customerAccount', label: 'Account Number'},
      {value: 'serviceAddress', label: 'Service Address'},
      {value: 'meterNumber', label: 'Meter Number'},
      {value: 'payBy', label: 'Pay By Who'},
      {value: 'prop', label: 'Prop'},
      {value: 'unit', label: 'Unit'},
      {value: 'vendorName', label: 'Vendor'},
      {value: 'remark', label: 'Check Memo'},
      {value: 'invoice', label: 'Invoice'},
      {value: 'invoiceDate', label: 'Invoice Date'},
      {value: 'amount', label: 'Check Amount'},
      {value: 'postedDate', label: 'Check Date'},
      {value: 'clearedDate', label: 'Cashed Date'},
      {value: 'usid', label: 'Printed By'},
    ]
    return (
      <>
        {formItemList.map(item => (
          <Form.Item name={item.value} label={item.label}>
            <Input
              disabled
              style={{
                color: "rgba(0, 0, 0, 0.85)",
                backgroundColor: "#d2d6de",
                cursor: "not-allowed",
              }}
            />
        </Form.Item>
        ))}
      </>
    )
  }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
          <CreditCardOutlined style={{ marginRight: "8px" }} />
           VIEW PAYMENT
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={open}
      onCancel={handleCancel}
      footer={null}
      width="80%"
      maskClosable={false}
    >
      <Form form={form} layout="horizontal" labelCol={{span: 8}} wrapperCol={{span: 16}} labelWrap={true} labelAlign="right">
        <Row gutter={[16, 16]}>
          <Col span={10}>
            <div
              style={{
                marginBottom: "14px",
                fontWeight: "normal",
                fontSize: "20px",
              }}
            >
              <CreditCardOutlined style={{ marginRight: "8px" }} />
              View Utility Vendor Payment
            </div>

            <ConfigProvider componentDisabled={true}>
              {formItemDocFn()}
            </ConfigProvider>
          </Col>

          <Col span={14}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <FileImageOutlined style={{ marginRight: "8px" }} />
              Upload PDF image
            </div>
            <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} name="uploadFile" label={null} key={record?.vendorPaymentId}>
              <CustomUpload
                setFilePaths={setFilePaths} 
                filePaths={filePaths} 
                setBtnDisabled={setBtnDisabled}
                btnDisabled={true}
                isEdit={true}
                vendorPaymentId={record?.vendorPaymentId || undefined}
                foreignId={record?.vendorUtilPaymentId || undefined}
                type={'util_payment'}
                customConfig={{
                  pdfHeight: '80vh',
                  disabled:true
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="btnCenter">
          <Space align="center">
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UtilityPaymentModal;
